import flowValveApi from '@/api/config/flowValveApi'
import { queryKeys } from '@/constant/common'
import { APIResponseList } from '@/types'
import { FlowValveType } from '@/types/hydraulic'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchFlowValve(
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<FlowValveType>, any> {
  return useQuery(
    [queryKeys.flowValve],
    async () => {
      const { data } = await flowValveApi.getAll({
        interfaceId,
      })

      if (!data) return null

      return {
        list: data.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchFlowValve
